/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Meal_Lunch_DishInputs */

const en_for_whom_meal_lunch_dish = /** @type {(inputs: For_Whom_Meal_Lunch_DishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chicken, rice and vegetables`)
};

const pl_for_whom_meal_lunch_dish = /** @type {(inputs: For_Whom_Meal_Lunch_DishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurczak, ryż i warzywa`)
};

/**
* | output |
* | --- |
* | "Chicken, rice and vegetables" |
*
* @param {For_Whom_Meal_Lunch_DishInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_meal_lunch_dish = /** @type {((inputs?: For_Whom_Meal_Lunch_DishInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Meal_Lunch_DishInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_meal_lunch_dish(inputs)
	return en_for_whom_meal_lunch_dish(inputs)
});